const validateCheckables = require('../common/validate-checkables-atleastone');
const validateSelect = require('../common/validate-select');
const validateTextField = require('../common/validate-textfield');

module.exports = {
	init: () => {
		window.jQuery('#continueSurveys').on('click', submitSurvey);
		return;
	}
};

const submitSurvey = (e) => {
	//e.preventDefault();
	let success = validate();
	return success;
};

const validate = () => {
	let error = validateCheckables(window.iq.checkables.join(','));
	error = validateTextField('input:text.isRequired') || error;
	error = validateTextField('textarea.isRequired') || error;
	error = validateSelect('select.isRequired') || error;
	return !error;
};
